module.exports = __webpack_public_path__ + "img/role03.8718add5.png";